import Forecast               from 'scripts/defa/weather/model-forecast';
import Forecasts              from 'scripts/defa/weather/collection-forecasts';
import ForecastView           from 'scripts/defa/weather/view-forecast-view';
import ForecastTodayView      from 'scripts/defa/weather/view-forecast-today-view.js';
import ForecastCollectionView from 'scripts/defa/weather/view-forecast-collection-view';
import Module                 from 'scripts/module';

const WeatherModule = new Module( 'WeatherModule', {
	collections: {
		Forecasts,
	},
	models     : {
		Forecast,
	},
	views      : {
		ForecastCollectionView,
		ForecastTodayView,
		ForecastView,
	}
} );

export default WeatherModule;